import { styled } from '@/stitches.config';

export const Th = styled('th', {
  py: '$space-3',
  px: '$space-4',
  minHeight: 58,
  textAlign: 'left',
  verticalAlign: 'middle',
});

export const Td = styled('td', {
  py: '$space-3',
  px: '$space-4',
  minHeight: 58,
  textAlign: 'center',
  verticalAlign: 'middle',
});

export const Tr = styled('tr', {
  [`& ${Th}, & ${Td}`]: {
    '&:not(:last-child)': {
      borderRight: '1px solid $white',
    },
  },
});

export const Thead = styled('thead', {
  [`& ${Th}, & ${Td}`]: {
    color: '$white',
    fontFamily: '$bold',
    fontSize: '16px',
    bc: '$primary100',
    py: '$space-2',
    px: '$space-4',
    textAlign: 'center',
    borderBottom: '1px solid $white',
    '@sm': {
      py: '$space-4',
    },
  },
  variants: {
    size: {
      small: {
        [`& ${Th}, & ${Td}`]: {
          py: '$space-2',
        },
      },
    },
  },
});

export const Tbody = styled('tbody', {
  [`& ${Tr}`]: {
    [`& ${Th}, & ${Td}`]: {
      bc: '$gray300',
    },
    '&:nth-child(odd)': {
      [`& ${Th}, & ${Td}`]: {
        bc: '$gray200',
      },
    },
    '&:not(:last-child)': {
      [`& ${Th}, & ${Td}`]: {
        borderBottom: '1px solid $white',
      },
    },
  },
  [`& ${Th}, & ${Td}`]: {
    fontSize: '15px',
    py: '$space-2',
    px: '$space-4',
    '@sm': {
      py: '$space-4',
    },
  },
  [`& ${Th}`]: {
    textAlign: 'left',
  },
  [`& ${Td}`]: {
    textAlign: 'center',
  },
  variants: {
    size: {
      small: {
        [`& ${Th}, & ${Td}`]: {
          py: '$space-2',
        },
      },
    },
  },
});

export const Tfoot = styled('tfoot', {
  [`& ${Tr}`]: {
    bc: '$gray800',
  },
  [`& ${Th}, & ${Td}`]: {
    fontFamily: '$bold',
    color: '$white',
  },
});

export const Table = styled('table', {
  width: '100%',
  tableLayout: 'fixed',
  borderCollapse: 'collapse',
  borderSpacing: 0,
  variants: {
    striped: {
      true: {
        [`& ${Tbody}`]: {
          [`& ${Tr}`]: {
            '&:nth-child(odd)': {
              bc: '$gray200',
            },
          },
        },
      },
    },
  },
});
